import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterAutocomplete_template} from "./filterAutocomplete_template";

declare var ko: any;

export class modGameList_template extends vnTemplate {


    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    public tagFilter: filterAutocomplete_template;

    protected getTemplateHtml(): string {
        return /*html*/`
                <div class="list-header w-justify" >

                    <div class="w-left">
                        <button data-bind="click: function() { onClickShowPopUp('add') }" class="btn secondary icon i-add" type="button">Add Game</button>
                    </div>

                    <div class="w-center">
                        ${this.filter.getHtmlBuild()}
                    </div>

                    <div class="w-right">
                        ${this.pagination.getHtmlBuild()}
                    </div>
                </div>


                <div class="w-list-results" id="list-results">
                    <table class="list-results">
                        ${this.resultInfos.getHtmlBuild()}
                        <thead>
                            <tr>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'name') }, css: { 'list-sort-desc': orderByAndDirection()=='name_DESC', 'list-sort-asc': orderByAndDirection()=='name_ASC' }">Name</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                                <th><span>Delete</span></th>
                            </tr>
                        </thead>
                        <tbody data-bind="foreach: games">
                            <tr class="cursor">
                                <td><a class="right-click"><span data-bind="text: $data.tag.name"></span></a></td>
                                <td><a class="right-click"><span data-bind="text: $data.dateCreated"></span></a></td>
                                <td><a class="right-click"><span data-bind="text: $data.dateUpdated"></span></a></td>
                                <td class="align-right"><button type="button" data-bind="event: { click: $parent.onClickShowDeletePopUp }, clickBubble: false" class="btn border only-icon icon i-delete"></button></td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="w-lightbox light-theme" data-bind="css: { 'is-visible' : isVisible }">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title" data-bind="text: popupAction() + ' Game'"></h3>
                                <button type="button"  data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <label class="form-label">Game (Tag)</label>
                                    ${ this.tagFilter.getHtmlBuild() }
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickCancel }" class="btn border only-icon icon">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickSave }" class="btn border only-icon icon">Save</button>
                            </div>
                        </div>

                    </div>
                </div>

                <div id="delete-dialog" class="w-lightbox light-theme">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Deleting game</h3>
                                <button type="button"  data-bind="event: { click: onClickHideDeletePopUp }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group">
                                    <p class="form-text">Are you sure you want to delete this game :

                                        <p data-bind=" if: idGameToDelete() !== null && idGameToDelete().tag !== null ">
                                        <span data-bind="text: idGameToDelete().tag.name"></span>
                                        </p>

                                    </p>
                                </div>
                            </div>

                            <div class="form-footer">
                                <button type="button" data-bind="event: { click: onClickHideDeletePopUp }" class="btn">Cancel</button>
                                <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                            </div>
                        </div>

                    </div>
                </div>


         `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 50;
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.tagFilter = new filterAutocomplete_template("filterAutocomplete_tagFilter", this.getTemplateViewModel(), this.caller);
        this.tagFilter.setPlaceholder('Search for a game...');
        this.tagFilter.setLabel('Game');
    }

    protected getTemplateName(): string {
        return "modGameList_template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {
        let self = this
        return {
            games: ko.observableArray([]),
            orderBy: ko.observable("name"),
            orderByDirection: ko.observable("ASC"),
            orderByAndDirection: ko.observable("name_ASC"),
            isVisible: ko.observable(false),
            showParentName: ko.observable(false),
            popupAction: ko.observable("add"),
            idGameToDelete: ko.observable(null),
            selectedTag: ko.observable(null),
            onClickReorder: function (value, data, event) {
                self.onClickReorder(value, data, event);
            },
            onClickShowPopUp: function (value, data, event) {
                self.onClickShowPopUp(value)
            },
            onClickShowDeletePopUp: function (value, data, event) {
                self.onClickShowDeletePopUp(value)
            },
             onClickHideDeletePopUp: function (value, data, event) {
                self.onClickHideDeletePopUp()
            },
            onClickCancel: function (value, data, event) {
                self.onClickCancel()
            },
            onClickSave: function (value, data, event) {
                self.onClickSave()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            }
        }
    }


    public getViewModelForRequest() {

        return {
            orderBy: this.getTemplateViewModel().orderBy(),
            orderByDirection: this.getTemplateViewModel().orderByDirection(),
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection(),
            pagination: this.getTemplateViewModel().pagination,
            filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword(),
            }
        }
    }

    public onClickReorder(value, data, event) {

        data.orderBy(value);

        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.gamesListReorder();
    }

    public setGames(games) {

        this.getTemplateViewModel().games(games);
    }

    public setResultInfo(nbResults, nbPages, execTime ) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickShowPopUp(action) {
        if (action === 'add') {
            this.getTemplateViewModel().selectedTag(null);
            this.tagFilter.clearEverything();
        }

        this.getTemplateViewModel().popupAction(action);
        this.getTemplateViewModel().isVisible(true);
    }

    public onClickHideDeletePopUp(): any {
        this.getTemplateViewModel().idGameToDelete(null);
        this.toggleDeleteDialogVisibility()
    }
    public onClickShowDeletePopUp(data): any {

        this.getTemplateViewModel().idGameToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    public onClickCancel() {
        this.getTemplateViewModel().isVisible(false);
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }


    public onClickSave() {
        let selectedTag = this.getTemplateViewModel().selectedTag();
        if (!selectedTag) {
            return;
        }
        this.getTemplateViewModel().isVisible(false);
        this.caller.addGame(selectedTag.id);
    }

    public onClickDelete() {
        let game_id = this.getTemplateViewModel().idGameToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteGame(game_id);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/modGameList_template.ts